export const ID = 'SC52'
